export default function DataSection() {
  return (
    <div className="space-y-5 pb-4 text-neutral-950">
      <h1 className="text-lg leading-6 font-bold -tracking-wide">
        Data Confidentiality
      </h1>

      <div className="rounded-xl bg-[#FFFBEB] p-3">
        <h1 className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
          CONFIDENTIALITY NOTICE
        </h1>
        <p className="text-sm leading-[140%] font-medium tracking-normal">
          This system contains classified and sensitive information that must be
          handled in accordance with organizational security policies and
          applicable legal requirements.
        </p>
      </div>

      <div className="space-y-2">
        <h1
          id="classification"
          className="text-[18px] leading-5 font-bold -tracking-wide"
        >
          Classification Levels and Handling
        </h1>
        <div className="space-y-2">
          <h1 className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
            Restricted Data
          </h1>
          <ul className="list-inside list-disc pl-2 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Definition: &nbsp;
              </span>{" "}
              Information that could cause damage if disclosed
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Handling: &nbsp;
              </span>
              Access limited to authorized personnel only
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Examples: &nbsp;
              </span>
              Personnel records, financial data, strategic plans
            </li>
          </ul>
        </div>
        <div className="space-y-2">
          <h1 className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
            Confidential Data
          </h1>
          <ul className="list-inside list-disc pl-2 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Definition: &nbsp;
              </span>{" "}
              Information that could cause serious damage if disclosed
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Handling: &nbsp;
              </span>
              Requires encryption at rest and in transit
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Examples: &nbsp;
              </span>
              Customer data, proprietary algorithms, security protocols
            </li>
          </ul>
        </div>
        <div className="space-y-2">
          <h1 className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
            Top Secret Data
          </h1>
          <ul className="list-inside list-disc pl-2 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Definition: &nbsp;
              </span>
              Information that could cause exceptionally grave damage if
              disclosed
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Handling: &nbsp;
              </span>
              Maximum security measures required
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Examples: &nbsp;
              </span>
              National security information, critical infrastructure data
            </li>
          </ul>
        </div>
      </div>
      <div className="space-y-2">
        <h1
          id="security-practices"
          className="text-[18px] leading-5 font-bold -tracking-wide"
        >
          Mandatory Security Practices
        </h1>
        <div className="space-y-2">
          <ol className="list-inside list-decimal space-y-2 pl-2 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
              Access Control
            </li>
            <ul className="list-inside list-disc pl-1">
              <li>Use role-based access controls (RBAC)</li>
              <li>Implement principle of least privilege</li>
              <li>Regular access reviews and audits</li>
            </ul>
            <li className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
              Data Protection
            </li>
            <ul className="list-inside list-disc pl-1">
              <li>Encrypt sensitive data using AES-256 or equivalent</li>
              <li>Secure data transmission with TLS 1.3</li>
              <li>Regular security assessments and penetration testing</li>
            </ul>
            <li className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
              Incident Reporting
            </li>
            <ul className="list-inside list-disc pl-1">
              <li>Report any suspected data breaches immediately</li>
              <li>Contact Security Team: security@organization.com</li>
              <li>Document all incidents in compliance system</li>
            </ul>
            <li className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
              Data Retention
            </li>
            <ul className="list-inside list-disc pl-1">
              <li>Follow established data retention policies</li>
              <li>Secure disposal of classified materials</li>
              <li>Regular purging of expired sensitive data</li>
            </ul>
          </ol>
        </div>
      </div>
    </div>
  );
}
